import React from 'react';

import './FormFooter.scss';

export default function FormFooter(props) {
  return <div className="mio-form-footer" {...props} />;
}
